import { BookOpen, Route } from 'lucide-react'

import type { MyData } from '../types'

import { DeleteAccountSection } from './DeleteAccountSection'
import { EntityListCard } from './EntityListCard'
import { MissionsCard } from './MissionsCard'
import { PersonalDataCard } from './PersonalDataCard'
import { ProgressStatsRow } from './ProgressStatsRow'

// Aba "Meus Dados": visão geral do inventário LGPD do aluno (progresso, dados
// pessoais, jornadas, missões, biblioteca) + exclusão de conta.
export function AccountOverviewTab({ record }: { record: MyData }) {
  return (
    <div className="flex flex-col gap-4">
      <ProgressStatsRow progress={record.jornadas.progresso} />

      <PersonalDataCard personal={record.dados_pessoais} />

      <EntityListCard
        title="Jornadas concluídas"
        headerIcon={Route}
        rowIcon={Route}
        items={record.jornadas.concluidas}
        emptyMessage="Você ainda não concluiu nenhuma jornada."
        emptyCta={{ label: 'Explorar jornadas', href: '/jornadas' }}
      />

      <MissionsCard
        concluidas={record.missoes.concluidas}
        emAndamento={record.missoes.em_andamento}
      />

      <EntityListCard
        title="Materiais baixados"
        headerIcon={BookOpen}
        rowIcon={BookOpen}
        items={record.biblioteca.materiais}
        emptyMessage="Você ainda não baixou nenhum material."
        emptyCta={{ label: 'Ir para a biblioteca', href: '/biblioteca' }}
      />

      <DeleteAccountSection />
    </div>
  )
}
